(function () {
  'use strict';

  angular
    .module('web2print')
    .filter('imagePath', imagePath);

  function imagePath () {
    return imagePathFilter;

    function imagePathFilter (input) {
      if (!input) return;

      const localPath = 'assets/images/';

      return localPath + input;
    }
  }
})();
